import {
  ContextField,
  ContextSelectedOptions,
  ContextSelector
} from "@appretio/context-selector";
import { Button, DataTable, Dialog, Sheet } from "@appretio/ui-kit";
import { GridOptions } from "ag-grid-enterprise";
import { useMemo, useState } from "react";
import { activeDeactivateCellRenderer } from "../../components/demo-dataTable/cellRenderComponent/activateDeactivateCellRender";
import { columnDefs } from "../../components/demo-dataTable/colDefMock";
import rowData from "../../components/demo-dataTable/rowDataMock.json";
import {
  contextActionsContainer,
  contextContainer,
  contextSelectorsContainer
} from "./PlaybookPage.css";

/**
 * Handles which values are fetched and displayed by the ContextSelector
 */
const LIFECYCLE_CONTEXT_OPTIONS: ContextField[] = [
  "brand",
  "sub_brand",
  "product_line",
  "collection_type",
  "product_category",
  "collection_name",
  "country",
  "sales_location"
];

export function PlaybookPage() {
  const [selectedContextOptions, setSelectedContextOptions] =
    useState<ContextSelectedOptions>({});

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState<
    | { style_option_number?: string; appretio_thumbnail_url?: string }
    | undefined
  >();

  function clearSelectedOption() {
    setSelectedContextOptions({});
  }

  const gridOptions: GridOptions = useMemo(
    () => ({
      enableGroupEdit: true,
      suppressScrollOnNewData: true,
      cellSelection: true,
      autoGroupColumnDef: {
        headerName: "Style Option ID",
        pinned: "left",
        width: 100
      },
      columnTypes: {
        activation: {
          cellRenderer: activeDeactivateCellRenderer,
          cellStyle: { textAlign: "center" },
          width: 50
        }
      }
    }),
    []
  );

  return (
    <>
      <Sheet>
        <div className={contextContainer}>
          <div className={contextSelectorsContainer}>
            <ContextSelector
              fields={LIFECYCLE_CONTEXT_OPTIONS}
              selected={selectedContextOptions}
              setSelected={setSelectedContextOptions}
            />
          </div>
          <div className={contextActionsContainer}>
            <Button variant="secondary" onClick={clearSelectedOption}>
              Clear
            </Button>
            <Button>Apply</Button>
          </div>
        </div>
      </Sheet>
      <Sheet>
        <div style={{ height: "calc(100vh - 14rem)", width: "100%" }}>
          <Dialog
            title="Example Dialog"
            description="Make changes to your profile here. Click save when you're done."
            confirmText="Save changes"
            cancelText="Cancel"
            size="sm"
            hideCloseIcon={false}
            open={dialogOpen}
            onOpenChange={setDialogOpen}
            modal={true}
            children={
              <div>
                <>{dialogContent?.style_option_number}</>
                <img
                  src={dialogContent?.appretio_thumbnail_url}
                  alt={dialogContent?.style_option_number || "Style Option"}
                />
              </div>
            }
          ></Dialog>
          <DataTable
            rowData={rowData}
            columnDefs={columnDefs}
            onRowClicked={(event) => {
              setDialogOpen(true);
              setDialogContent(event.data ? event.data : event.node.aggData);
            }}
            rowHeight={75}
            gridOptions={gridOptions}
          />
        </div>
      </Sheet>
    </>
  );
}
